export const kebabToCamel = (str = "") => str.replace(/-([a-z])/g, (_m, w) => w.toUpperCase());
export const camelToKebab = (string = "") => string.replace(/([A-Z])/g, (_match, group) => `-${group.toLowerCase()}`).replace(/^-/, "");
export const toSnakeCase = (str = "") => str
    // Replace all non-alphanumeric characters and spaces with underscores
    .replace(/[\W\s]+/g, "_")
    // Add an underscore before any uppercase letter that is preceded by a lowercase letter
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    // Convert the entire string to lowercase
    .toLowerCase();
export const capitalizeFirstLetter = (str) => {
    if (str.length === 0)
        return str; // Handle empty strings
    return str.charAt(0).toUpperCase() + str.slice(1);
};
/**
 * Formats a list of strings into a human-readable string with a conjunction.
 * Uses Oxford comma style for lists with 3+ items.
 *
 * @param items - Array of strings to format
 * @param conjunction - The word to use before the last item (e.g., "and", "or")
 * @returns Formatted string (e.g., "A", "A and B", "A, B, and C")
 *
 * @example
 * formatListWithConjunction([], "and") // ""
 * formatListWithConjunction(["Apple"], "and") // "Apple"
 * formatListWithConjunction(["Apple", "Banana"], "and") // "Apple and Banana"
 * formatListWithConjunction(["Apple", "Banana", "Cherry"], "and") // "Apple, Banana, and Cherry"
 */
export const formatListWithConjunction = (items, conjunction) => {
    if (items.length === 0)
        return "";
    if (items.length === 1)
        return items[0];
    if (items.length === 2)
        return `${items[0]} ${conjunction} ${items[1]}`;
    return `${items.slice(0, -1).join(", ")}, ${conjunction} ${items[items.length - 1]}`;
};
